import { useMutation, useQuery } from 'react-query';

import {
  createMatrixCustomerSettings,
  getMatrixCustomerSettings,
  updateMatrixCustomerSettings,
} from './MatrixCustomerSettings.service';

import { notification } from 'antd';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import notificationError from '@/utils/functions/notificationError';

export function useMatrixCustomerSettingsDetails(enabled = true) {
  return useQuery(
    ['matrix-customer-settings'],
    () => getMatrixCustomerSettings(),
    {
      enabled,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useMatrixCustomerSettingsCreate() {
  const queryChanel = useQueryChanel();

  return useMutation(createMatrixCustomerSettings, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'As configurações do cliente foram criadas com sucesso!',
      });

      queryChanel({
        invalidateQueries: [['matrix-customer-settings']],
        refetchQueries: [['matrix-customer-settings']],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useMatrixCustomerSettingsUpdate() {
  const queryChanel = useQueryChanel();

  return useMutation(updateMatrixCustomerSettings, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'As configurações do cliente foram salvas com sucesso!',
      });

      queryChanel({
        invalidateQueries: [['matrix-customer-settings']],
        refetchQueries: [['matrix-customer-settings']],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
